import { createAction, props } from '@ngrx/store';
import { ApiPermissions } from 'src/app/utils/interfaces/auth.interfaces';
import { IDataAction } from '../../utils/interfaces/common.interfaces';
import { BasicFirmwareInfo, MacRange, ProducedDevice } from 'src/app/generated/CrossPoint.ProductionTooling.Server';
import { IGetDevicesData } from 'src/app/utils/interfaces/production.interfaces';
import { DeviceProfiles, ETagItem } from 'src/app/utils/interfaces/store.interfaces';

export enum ProductionToolingActionsTypes {  
  GET_AUTH_INFO_PRODUCTION_TOOLING = '[PROD-TOOL] GET_AUTH_INFO_TOOLING_PRODUCTION',
  GET_AUTH_INFO_PRODUCTION_TOOLING_SUCCESS = '[PROD-TOOL] GET_AUTH_INFO_PRODUCTION_TOOLING_SUCCESS',
  GET_AUTH_INFO_PRODUCTION_TOOLING_FAILED = '[PROD-TOOL] GET_AUTH_INFO_PRODUCTION_TOOLING_FAILED',

  GET_DEVICES = '[PROD-TOOL] GET_DEVICES',
  GET_DEVICES_SUCCESS = '[PROD-TOOL] GET_DEVICES_SUCCESS',
  GET_DEVICES_FAILED = '[PROD-TOOL] GET_DEVICES_FAILED',

  GET_FIRWMARE = '[PROD-TOOL] GET_FIRMWARE',
  GET_FIRWMARE_SUCCESS = '[PROD-TOOL] GET_FIRWMARE_SUCCESS',
  GET_FIRWMARE_FAILED = '[PROD-TOOL] GET_FIRWMARE_FAILED',

  GET_PROFILES = '[PROD-TOOL] GET_PROFILES',
  GET_PROFILES_SUCCESS = '[PROD-TOOL] GET_PROFILES_SUCCESS',
  GET_PROFILES_FAILED = '[PROD-TOOL] GET_PROFILES_FAILED',

  SET_PROFILES = '[PROD-TOOL] SET_PROFILES',
  SET_PROFILES_SUCCESS = '[PROD-TOOL] SET_PROFILES_SUCCESS',
  SET_PROFILES_FAILED = '[PROD-TOOL] SET_PROFILES_FAILED',

  GET_MAC_RANGES = '[PROD-TOOL] GET_MAC_RANGES',
  GET_MAC_RANGES_SUCCESS = '[PROD-TOOL] GET_MAC_RANGES_SUCCESS',
  GET_MAC_RANGES_FAILED = '[PROD-TOOL] GET_MAC_RANGES_FAILED',

  ADD_MAC_RANGE = '[PROD-TOOL] ADD_MAC_RANGE',
  ADD_MAC_RANGE_SUCCESS = '[PROD-TOOL] ADD_MAC_RANGE_SUCCESS',
  ADD_MAC_RANGE_FAILED = '[PROD-TOOL] ADD_MAC_RANGE_FAILED',

  DELETE_MAC_RANGE = '[PROD-TOOL] DELETE_MAC_RANGE',
  DELETE_MAC_RANGE_SUCCESS = '[PROD-TOOL] DELETE_MAC_RANGE_SUCCESS',
  DELETE_MAC_RANGE_FAILED = '[PROD-TOOL] DELETE_MAC_RANGE_FAILED',
}

export const getAuthInfoProductionToolingAction = createAction(ProductionToolingActionsTypes.GET_AUTH_INFO_PRODUCTION_TOOLING);
export const getAuthInfoProductionToolingSuccessAction = createAction(ProductionToolingActionsTypes.GET_AUTH_INFO_PRODUCTION_TOOLING_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoProductionToolingFailedAction = createAction(ProductionToolingActionsTypes.GET_AUTH_INFO_PRODUCTION_TOOLING_FAILED);

export const getDevicesAction = createAction(ProductionToolingActionsTypes.GET_DEVICES, props<IDataAction<IGetDevicesData>>());
export const getDevicesSuccessAction = createAction(ProductionToolingActionsTypes.GET_DEVICES_SUCCESS, props<IDataAction<ProducedDevice[]>>());
export const getDevicesFailedAction = createAction(ProductionToolingActionsTypes.GET_DEVICES_FAILED);

export const getFirmwareAction = createAction(ProductionToolingActionsTypes.GET_FIRWMARE);
export const getFirmwareSuccessAction = createAction(ProductionToolingActionsTypes.GET_FIRWMARE_SUCCESS, props<IDataAction<BasicFirmwareInfo[]>>());
export const getFirmwareFailedAction = createAction(ProductionToolingActionsTypes.GET_FIRWMARE_FAILED);

export const getDeviceProfilesAction = createAction(ProductionToolingActionsTypes.GET_PROFILES);
export const getDeviceProfilesSuccessAction = createAction(ProductionToolingActionsTypes.GET_PROFILES_SUCCESS, props<IDataAction<ETagItem<DeviceProfiles>>>());
export const getDeviceProfilesFailedAction = createAction(ProductionToolingActionsTypes.GET_PROFILES_FAILED);

export const setDeviceProfilesAction = createAction(ProductionToolingActionsTypes.SET_PROFILES, props<IDataAction<ETagItem<DeviceProfiles>>>());
export const setDeviceProfilesSuccessAction = createAction(ProductionToolingActionsTypes.SET_PROFILES_SUCCESS, props<IDataAction<ETagItem<DeviceProfiles>>>());
export const setDeviceProfilesFailedAction = createAction(ProductionToolingActionsTypes.SET_PROFILES_FAILED);

export const getMacRangesAction = createAction(ProductionToolingActionsTypes.GET_MAC_RANGES);
export const getMacRangesSuccessAction = createAction(ProductionToolingActionsTypes.GET_MAC_RANGES_SUCCESS, props<IDataAction<MacRange[]>>());
export const getMacRangesFailedAction = createAction(ProductionToolingActionsTypes.GET_MAC_RANGES_FAILED);

export const addMacRangeAction = createAction(ProductionToolingActionsTypes.ADD_MAC_RANGE, props<IDataAction<MacRange>>());
export const addMacRangeSuccessAction = createAction(ProductionToolingActionsTypes.ADD_MAC_RANGE_SUCCESS, props<IDataAction<MacRange>>());
export const addMacRangeFailedAction = createAction(ProductionToolingActionsTypes.ADD_MAC_RANGE_FAILED, props<IDataAction<MacRange>>());

export const deleteMacRangeAction = createAction(ProductionToolingActionsTypes.DELETE_MAC_RANGE, props<IDataAction<string>>());
export const deleteMacRangeSuccessAction = createAction(ProductionToolingActionsTypes.DELETE_MAC_RANGE_SUCCESS, props<IDataAction<string>>());
export const deleteMacRangeFailedAction = createAction(ProductionToolingActionsTypes.DELETE_MAC_RANGE_FAILED, props<IDataAction<string>>());